<template>
  <div class="gd-modal">
    <div class="gd-modal__bckg" @click="closeModal()"></div>
    <div class="gd-modal__body">
      <div class="gd-modal__title">
        Dupliquer la configuration <b>{{configuration.conf.name}}</b>
        <button
          class="gd-rounded-btn gd-modal__close"
          @click="closeModal()">
          <IconClose class="gd-rounded-btn__icon"></IconClose>
        </button>
      </div>
      <div class="gd-modal__content">
        <p>
          <b>Type de document :</b> {{configuration.fileType}}
        </p>
        <div>
          <p>
            <b>Rappel des métadonnées associés à la configuration :</b>
          </p>
          <span
            :key="`metadata${index}`"
            class="gd-tag gd-tag--dark-grey gd-m-b-5 gd-m-r-5"
            v-for="(metadata, index) in
                    configuration.conf.metadatas">
                    {{ metadata.friendlyName }}
          </span>
        </div>
        <p>
          <label for="newConfigName">
            Choisissez un nouveau nom pour la configuration à dupliquer :
          </label>
          <input
            id="newConfigName"
            ref="inputRef"
            type="text"
            class="gd-input-text"
            required
            v-model="configurationName"
            autocomplete="nom de la configuration">
        </p>
        <div class="gd-text-center">
          <button v-on:click="saveDuplicateConfiguration" class="gd-default-btn">
            Sauvegarder la configuration
          </button>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import IconClose from '@/assets/svg/icon-close.svg';

export default {
  name: 'DuplicateConfiguration',
  components: {
    IconClose,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      configurationName: '',
    };
  },
  methods: {
    ...mapActions({
      duplicateConfiguration: 'lad/duplicateConfiguration',
    }),
    saveDuplicateConfiguration() {
      if (document.getElementById('newConfigName').checkValidity() && this.configurationName.trim().length > 0) {
        this.duplicateConfiguration({
          name: this.configurationName.trim(),
          fileType: this.configuration.fileType,
          metadatas: this.configuration.conf.metadatas,
        })
          .then((data) => {
            if (data.status === 200) {
              this.closeModal();
            }
          });
      } else {
        this.$store.dispatch('app/openSnackbar', {
          message: 'Veuillez entrer un nom pour cette nouvelle configuration',
        });
      }
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DuplicateConfiguration.vue